// toastHelper.tsx
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from '@mui/material';

export const showToast = (message: string, type: "info" | "success" | "warning" | "error" = "info") => {
  toast[type](message, {
    position: "top-right",
    autoClose: 900,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}


export const showSessionExpiredToast = (onConfirm:any) => {
  toast.warning(
    ({ closeToast }:any) => (
      <div className='d-flex align-self-strech justify-content-between'>
        <p>Oturum süresi dolmuştur. Lütfen tekrar giriş yapınız.</p>
        <Button    color="primary" onClick={() => {
          onConfirm();
          closeToast();
        }}>
          Giriş Yap
        </Button>
      </div>
    ),
    {
      autoClose: false, // Otomatik kapanmayı kapat
      closeOnClick: false, // Tıklama ile kapanmayı kapat
      onClose: onConfirm // Kapatma olayı gerçekleştiğinde yönlendir
    }
  );
};
